import * as React from "react";

interface Props {
    type?: "button" | "submit" | "reset";
    isDisabled?: boolean;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const IconButton: React.FC<Props> = ({ children, isDisabled, type, onClick }) => {
    return (
        <button type={type} onClick={onClick} disabled={isDisabled} className="icon-button">
            {children}
        </button>
    );
};
